// Video
jQuery(document).ready(function($) {

  // Play/pause button
  if($('.custom-video__play').length){
    $('.custom-video__play').click(function(e){
      e.preventDefault();
      let parent = $(this).closest('.custom-video');
      if(parent.hasClass('custom-video--playing')){
        parent.removeClass('custom-video--playing');
        parent.addClass('custom-video--paused');
        parent.find('video')[0].pause();
      }else{
        parent.addClass('custom-video--playing');
        parent.removeClass('custom-video--paused');
        parent.find('video')[0].play();
      }
    });

    $('.custom-video__pause').click(function(e){
      e.preventDefault();
      let parent = $(this).closest('.custom-video');
      parent.removeClass('custom-video--playing');
      parent.addClass('custom-video--paused');
      parent.find('video')[0].pause();
    });
  }

  // Fullwidth
  if($('.custom-video--full').length){
    //$('.custom-video--full').closest('.entry-content').addClass('u-full-width');
  }
});


